import { render, staticRenderFns } from "./ProjectClassScheduleView.vue?vue&type=template&id=5caabc54&scoped=true"
import script from "./ProjectClassScheduleView.vue?vue&type=script&lang=js"
export * from "./ProjectClassScheduleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caabc54",
  null
  
)

export default component.exports